import { Container, Button, Navbar, Nav, NavItem, NavDropdown, MenuItem, NavLink,FormControl ,Form, Alert, Col,Row} from 'react-bootstrap';
import React, { useState, Component, useMemo, useEffect } from 'react';
import {Sida,Rubrik,Stycke,ContentWrapper} from "../ContentStyles";
import useBackend, {XLogOff, IsLoggedIn, Loading, SpinnerX, CallDownload,CallAPIGet, Check} from '../../services/useBackend';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, metaLookUpTitle} from '../../services/misc';
import {MaterialReactTable} from 'material-react-table';
import Test from '../balkochhal/editRequestComponent';

function Report() {
    const [editRequestModalshow, setEditRequestModalshow] = useState(false);

    const [selectedRequestData, setSelectedRequestData] = useState({Contact: { Name:"N/A"}, RequestWF: [], RequestChilds : [], RequestLog : [], RequestFiles: [], UserID:0 });  
    const [contactData, setContactData] = useState({});    

    const {loading, data, Seek} =  useBackend('/api/report/resourceoverviewdetailed');
    const {loading:loadingmeta, data:metadata} =  useBackend(process.env.PUBLIC_URL+'/api/meta');    

    const [startDateDisabled, setStartDateDisabled] = useState(true);    

  var pageIndex = 0;
  var pageSize  = 100;

  const [pagination, setPagination] = useState({ pageIndex: pageIndex, pageSize: pageSize });    

    var today = new Date(Date.now());
    //var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const [startDate, setStartDate] = useState(today.toLocaleDateString());

    //var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth()+1, 0);
    var result = new Date(); // not instatiated with date!!! DANGER
    result.setDate(today.getDate() + 7);

    const [endDate, setEndDate] = useState(result.toLocaleDateString());

    const [reportFilter, setReportFilter] = useState(0);

    const initialState = { density: 'compact', columnVisibility: { }, pagination : pagination };    

    useEffect(() => { 
        Seek("&UserCategoryID="+reportFilter+"&startDate="+startDate+"&endDate="+endDate+"&startDateDisabled="+startDateDisabled);
        
    }, [reportFilter, startDate, endDate]);

    useEffect(() => { 
        if (startDateDisabled) { setStartDate('0001-01-01'); } else { setStartDate(today.toLocaleDateString()); }
        
    }, [startDateDisabled]);

    //useEffect(() => { if (loading==false) setStartDate(SplitoutLocalDateFromISO(data.minDate)) }, [data]);

    const editRequestHandler = async (event, rowData)  =>  {

        if (rowData.original.Request!=null) {
            let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPIGet('/api/requests/' + rowData.original.Request.Guid);
            setSelectedRequestData(jsondata.Request)
            setEditRequestModalshow(!editRequestModalshow);
        }
    }

    const columns = useMemo(() => [
            { size: 20, accessorKey:'Date', header: 'Date'        , enableColumnActions: false,
                Cell: ({ cell }) => SplitoutLocalDateFromISO(cell.getValue(),true),        
            },
            { size: 20, accessorKey:'estimatedTime', header: 'Est. time'        , enableColumnActions: false, 
                Cell: ({ cell }) => cell.getValue(),    
            },  
            { size: 40, accessorKey: 'Request.Identifier',   header: 'Identity', enableColumnActions: false },
            { size: 40, accessorKey: 'Request.Title',    header: 'Title', enableColumnActions: false },        
        ]
    );    

    return(
        <ContentWrapper>
                {!loading && !loadingmeta &&
                    <Test RequestData={selectedRequestData} MetaData={metadata} show={editRequestModalshow} fn={ ()=> { setEditRequestModalshow(!editRequestModalshow);  } } setSelectedRequestData={setSelectedRequestData} contactData={selectedRequestData.Contact} />
                }
                <Sida>
                    <Rubrik>Resource overview</Rubrik>

                    <Row>
                        <Col>Startdate</Col>
                        <Col>Enddate</Col>
                        <Col>Resuource Cathegory</Col>
                    </Row>

                    <Row>
                        <Col><Form.Control type="date" name="Name"  placeholder="Startdate" value={startDate} onChange={async (e) => {await setStartDate(e.target.value); }} disabled={startDateDisabled} /></Col>
                        <Col><Form.Control type="date" name="Name_" placeholder="Enddate"   value={endDate}   onChange={async (e) => {setEndDate(e.target.value); }} /></Col>
                        <Col>
                            <Form.Select name="UserCategoryID" m onChange={async (e) => {setReportFilter(e.target.value); }} >
                                {/* <option key="0" value="0">Alla</option>                                            */}
                                {!loadingmeta && getOptions(metadata.UserCategories)}
                            </Form.Select>                    
                        </Col>
                        {/* <Col><Button variant='secondary' onClick={() => {Seek("?startdate="+startDate+"&enddate="+endDate+"&ShopId="+shopFilter)}}>Sök/Uppdatera</Button> </Col> */}
                    </Row>

                    <Row>
                        <Col><Form.Check type="switch" label='Sätt startdatum automatiskt' defaultChecked={startDateDisabled} onChange={() => setStartDateDisabled(!startDateDisabled)}  /></Col>
                    </Row>

                    {!loading &&                                        
                        <MaterialReactTable columns={columns} data={data.reportcontent} initialState={initialState} enableExpandAll={false} enableExpanding={true}
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, rowsPerPageOptions: [25, 50, 75, 100], labelRowsPerPage:"Rader"}}                
                            muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0', border: '0px dashed #e0e0e0'} }} 
                            muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => {editRequestHandler(event, row);},sx: {cursor: 'pointer'},}
                            )}	
                        />
                    }                               

                    <Alert>
                    <Alert.Heading>Om resursöversikt</Alert.Heading>
                    •	Alla tider anges i minuter (en arbetsdag = 480 minuter)<br></br>
                    •	Det är viktigt att alla Task-typer och personal tillhör rätt resursgrupp. <a href="/reports/eccd1139-2e12-48dc-9dd3-2deebc1e7783">Resursgrupper</a> <a href="/reports/200238f7-02e7-46ad-8874-17de924f4f42">Användare</a><br></br>
                    •	Rapporten kommer vara tillförlitlig först efter att tider är inmatade på arbetsuppfterna/taskarna.
                    </Alert>  

                </Sida>    
        </ContentWrapper>
      );
   }

export default Report;